
import request from '@/axios/index.js'
// 提现申请
export function checkWithdrawInfo(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: '/user/center/checkWithdrawInfo'
    })
}
// 获取当前时间
export function getBusinessDay(data) {
    return request.axios({
        url: '/getBusinessDay',
        data:data,
        type:"post"
    })
}
// 确认信息
export function withdraw(data,loading) {
    return request.axios({
        url: '/customer/account/withdraw',
        data:data,
        type:"post",
        loading:loading
    })
}


// WEBPACK FOOTER //
// ./src/api/withdraw.js